




































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Card from '@/components/default/Card.vue';
import notificationService from '@/services/notificationService';
import externalInvoicesRepository from '@/modules/externalInvoices/externalInvoicesRepository';
import PdfViewer from '@/plugins/pdfjs/PdfViewer.vue';

import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import customersRepository from '@/services/customers/customersRepository';
import projectsRepository from '@/services/projectsRepository';
import ordersService from '@/modules/orders/ordersService';

import { DxTabs, DxAutocomplete } from 'devextreme-vue';

import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxLabel
} from 'devextreme-vue/form';
import {
  DxDataGrid,
  DxEditing
} from 'devextreme-vue/data-grid';

import { ExternalInvoiceStatus, ExternalInvoiceType } from '@/modules/externalInvoices/enums';
import { DxTextArea } from 'devextreme-vue/text-area';
import SaveBar from '@/modules/shared/savebar/SaveBar.vue';

import { EventLogsObjectType } from '@/modules/shared/eventlogs/enums';
import EventLogsTable from '@/modules/shared/eventlogs/components/EventLogsTable.vue';
import dxDataGrid from 'devextreme/ui/data_grid';
import ProjectIsOnHoldPopup from '@/components/projects/ProjectIsOnHoldPopup.vue';
import { DataSourceLoadOptionsBase, OrdersClient, OrdersLookupQuery } from '@/data/web-api-client';

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({
  components: {
    Card,
    PdfViewer,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
    DxTextArea,
    SaveBar,
    DxTabs,
    DxAutocomplete,
    EventLogsTable,
    DxDataGrid,
    DxEditing
  },
})
export default class ExternalInvoicesDetailPage extends Vue {
  invoice: IExternalInvoice = {
    purchaseOrderId: '',
    id: '',
    documentNumber: '',
    invoiceNumber: '',
    internalReference: '',
    bankTransferNotice: '',
    supplierId: '',
    supplierName: '',
    projectId: '',
    projectName: '',
    date: '',
    remarksInternal: '',
    status: 0,
    type: 0,
    receivedDate: '',
    dueDate: '',
    driveKey: '',
    lines: [],
    processed: false,
    cashDiscount: false,
    cashDiscountPercentage: 0,
    cashDiscountPeriod: 0,
    totalIncl: 0,
    totalTax: 0,
    totalExcl: 0,
    taxrate: 0,
    totalInclWithCashDiscount: 0,
    approverId: '',
    approverName: '',
    projectIsOnHold: false
  };
  loading = false;
  loadingDocument = false;
  initialised = false;
  documentAsUrl = '';
  pdfSize = 450;
  dirty = false;
  saving = false;
  changingStatus = false;
  navIndex = 0;
  disabled = false;

  private ordersClient = new OrdersClient(undefined, this.$axios);

  get ordersDatasource(): DataSource {
    return new DataSource({
      store: new dxCustomStore({
        key: 'id',
        load: async (loadOptions) => {
          if (loadOptions.searchExpr && loadOptions.searchValue && loadOptions.searchOperation) {
            loadOptions.filter =
                [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
          }

          const result = await this.ordersClient.lookup(new OrdersLookupQuery({
            projectId: this.invoice.projectId,
            supplierId: this.invoice.supplierId,
            options: DataSourceLoadOptionsBase.fromJS(loadOptions)
          }));

          return {
            data: result.data,
            totalCount: result.totalCount,
          };
        },
        byKey: async (val: any) => {
          return (await ordersService.getSingle(val)).data;
        },
      }),
      paginate: true,
    });
  }

  openOrder() {
    this.$router.push({ path: `/orders/${this.invoice.purchaseOrderId}` });
  }

  mounted() {
    this.loadData();
    this.pdfSize = window.innerHeight - 275;
  }

  private async loadData() {
    try {
      this.loading = true;
      this.invoice = (await externalInvoicesRepository.getSingle(this.$route.params.id)).data;
      this.loadDocument();
      this.disabled = this.invoice.projectIsOnHold;
      setTimeout(() => {
        this.initialised = true;

        if (this.$route.query.checkProjectOnHold === 'true' && this.invoice?.projectIsOnHold) {
          this.projectIsOnHoldPopup.show();
        }
      }, 200);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  async save(validateForm: boolean) {
    try {
      if (validateForm) {
        const form: any = this.$refs.EditPurchaseInvoiceForm;
        const validationResult = form.instance.validate();

        if (!validationResult.isValid) {
          notificationService.invalidForm();
          return;
        }
      }

      this.saving = true;
      const result = (await externalInvoicesRepository.update(this.invoice)).data;
      Object.assign(this.invoice, result);
      setTimeout(() => {
        this.dirty = false;
      }, 200);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  private async loadDocument() {
    try {
      this.loadingDocument = true;
      const document = (await externalInvoicesRepository.downloadDocument(this.$route.params.id)).data;
      this.documentAsUrl = window.URL.createObjectURL(document);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  async approve() {
    try {
      this.changingStatus = true;
      (await externalInvoicesRepository.approve(this.invoice.id));
      this.invoice.status = 1;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      setTimeout(() => {
        this.changingStatus = false;
      }, 200);
    }
  }

  async resetStatus() {
    try {
      if (!confirm('Ben je zeker dat je de status wilt resetten?')) {
        return;
      }
      this.changingStatus = true;
      (await externalInvoicesRepository.resetStatus(this.invoice.id));
      this.invoice.status = 0;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      setTimeout(() => {
        this.changingStatus = false;
      }, 200);
    }
  }

  async deny() {
    try {
      this.changingStatus = true;
      (await externalInvoicesRepository.deny(this.invoice.id));
      this.invoice.status = 2;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      setTimeout(() => {
        this.changingStatus = false;
      }, 200);
    }
  }

  async setPaid() {
    try {
      this.changingStatus = true;
      (await externalInvoicesRepository.setPaid(this.invoice.id));
      this.invoice.status = 10;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      setTimeout(() => {
        this.changingStatus = false;
      }, 200);
    }
  }

  private beforeRouteLeave(to: any, from: any, next: any) {
    if (this.dirty) {
      if (confirm('Er zijn onopgeslagen wijzigingen. Bent u zeker dat u wenst te veranderen van pagina?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  private setTotalPrice(e: any) {
    const currentRow = this.extendedInvoiceLinesTable?.getVisibleRows().find(r => r.isEditing);

    if (!currentRow?.data?.quantity || !currentRow?.data?.unitPrice) {
      return;
    }

    const totalPrice = currentRow.data.unitPrice * currentRow.data.quantity;

    this.extendedInvoiceLinesTable.cellValue(currentRow.rowIndex!, 'totalPrice', totalPrice);
  }

  get title() {
    return 'Aankoopfactuur ' + this.invoice.documentNumber;
  }

  get employees() {
    return this.$store.getters['employees/items'];
  }

  get supplierOptions() {
    const self = this;
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          load: async (loadOptions) => {
            const result = await customersRepository.get(loadOptions);
            return {
              data: result.data,
            };
          },
          byKey: async (val: any) => {
            if (self.invoice === null) {
              return {};
            }

            return {
              id: self.invoice.supplierId,
              displayName: self.invoice.supplierName,
            };
          },
        }),
        paginate: true,
      }),
      valueExpr: 'id',
      displayExpr: 'displayName',
      searchEnabled: true,
    };
  }

  get historyConfig(): IEventLogQuery {
    return {
      objectId: this.$route.params.id,
      type: EventLogsObjectType.ExternalInvoice,
    };
  }

  get projectsOptions() {
    const self = this;
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          key: 'id',
          load: async (loadOptions) => {
            if (Array.isArray(loadOptions.filter) &&
              loadOptions.filter.length > 1 && loadOptions.filter[0] === 'id') {

              return {
                  data: [],
                  totalCount: 0,
              };
            }

            if (loadOptions.searchExpr && loadOptions.searchValue && loadOptions.searchOperation) {
              loadOptions.filter =
                  [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
            }

            const result = await projectsRepository.lookup(loadOptions);

            return {
              data: result.data.data,
              totalCount: result.data.totalCount,
            };
          },
          byKey: async (val: any) => {
            return projectsRepository.getSingle(val).then((result: any) => {
              return result.data;
            });
          },
        }),
        paginate: true,
      }),
      valueExpr: 'id',
      displayExpr: 'name',
      searchExpr: 'name',
      searchEnabled: true,
      showClearButton: true,
    };
  }

  get fields() {
    return [
      {
        itemType: 'group',
        caption: 'Interne informatie',
        colCount: 2,
        items: [
          {
            itemType: 'simple',
            dataField: 'documentNumber',
            label: {
              text: 'Documentnr.',
            },
            disabled: true,
          },
          {
            itemType: 'simple',
            dataField: 'status',
            editorOptions: {
              items: [
                { value: ExternalInvoiceStatus.Received, text: 'Ontvangen' },
                { value: ExternalInvoiceStatus.Accepted, text: 'Aanvaard' },
                { value: ExternalInvoiceStatus.Rejected, text: 'Afgewezen' },
                { value: ExternalInvoiceStatus.Paid, text: 'Betaald' },
              ],
              valueExpr: 'value',
              displayExpr: 'text',
              searchEnabled: true,
            },
            editorType: 'dxSelectBox',
            label: {
              text: 'Status',
            },
            disabled: true,
          },
          {
            itemType: 'simple',
            dataField: 'receivedDate',
            editorOptions: { width: '100%', useMaskBehavior: true },
            editorType: 'dxDateBox',
            label: {
              text: 'Ontvangstdatum',
            },
            validationRules: [
              {type: 'required', message: 'Veld is verplicht'},
            ],
          },
          {
            itemType: 'simple',
            dataField: 'type',
            editorOptions: {
              items: [
                { value: ExternalInvoiceType.MaterialsOrder, text: 'Materiaal' },
                { value: ExternalInvoiceType.SubcontractorSettlement, text: 'Afrekening OA' },
                { value: ExternalInvoiceType.Other, text: 'Andere' },
              ],
              valueExpr: 'value',
              displayExpr: 'text',
              searchEnabled: true,
            },
            editorType: 'dxSelectBox',
            label: {
              text: 'Soort',
            },
            validationRules: [
              {type: 'required', message: 'Veld is verplicht'},
            ],
          },
          {
            itemType: 'simple',
            dataField: 'approverId',
            label: {
              text: 'Verantwoordelijke',
            },
            editorType: 'dxSelectBox',
            editorOptions: {
              items: this.employees,
              valueExpr: 'id',
              displayExpr: 'displayName',
              searchEnabled: true,
            },
          },
          {
            itemType: 'simple',
            dataField: 'projectId',
            label: {
              text: 'project',
            },
            editorType: 'dxSelectBox',
            editorOptions: this.projectsOptions,
          },
          {
            dataField: 'createdBy',
            label: {
              text: 'Aangemaakt door',
            },
            disabled: true,
            editorType: 'dxSelectBox',
            editorOptions: {
              items: this.employees,
              valueExpr: 'id',
              displayExpr: 'displayName',
              searchEnabled: true,
            },
          },
          {
            itemType: 'simple',
            dataField: 'createdOn',
            editorOptions: { width: '100%', useMaskBehavior: true },
            editorType: 'dxDateBox',
            label: {
              text: 'Aanmaakdatum',
            },
            disabled: true,
          },
          {
            dataField: 'lastUpdatedBy',
            label: {
              text: 'Gewijzigd door',
            },
            disabled: true,
            editorType: 'dxSelectBox',
            editorOptions: {
              items: this.employees,
              valueExpr: 'id',
              displayExpr: 'displayName',
              searchEnabled: true,
            },
          },
          {
            itemType: 'simple',
            dataField: 'lastUpdatedOn',
            editorOptions: { width: '100%', useMaskBehavior: true },
            editorType: 'dxDateBox',
            label: {
              text: 'Gewijzigd op',
            },
            disabled: true,
          },
        ],
      },
      {
        itemType: 'group',
        caption: 'Factuur informatie',
        colCount: 2,
        items: [
          {
            itemType: 'simple',
            dataField: 'supplierId',
            editorOptions: this.supplierOptions,
            editorType: 'dxSelectBox',
            label: {
              text: 'Leverancier',
            },
            validationRules: [
              {type: 'required', message: 'Veld is verplicht'},
            ],
          },
          {
            itemType: 'simple',
            dataField: 'invoiceNumber',
            label: {
              text: 'Factuurnr. Klant',
            },
          },
          {
            itemType: 'simple',
            dataField: 'bankTransferNotice',
            label: {
              text: 'OGM',
            },
          },
          {
            itemType: 'simple',
            dataField: 'internalReference',
            editorOptions: {
              dataSource: this.ordersDatasource,
              valueExpr: 'documentNumber',
              displayExpr: 'documentNumber',
              searchEnabled: true,
              showClearButton: true,
              onSelectionChanged: async (e: any) => {
                if (e && e.selectedItem && e.selectedItem.id) {
                  // SET PROJECT
                  if (!this.invoice.projectId || this.invoice.projectId === '') {
                    this.invoice.projectId = e.selectedItem.projectId;
                  }
                  // SET SUPPLIER
                  if (!this.invoice.supplierId || this.invoice.supplierId === '') {
                    this.invoice.supplierId = e.selectedItem.supplierId;
                    this.invoice.supplierName = e.selectedItem.supplierName;
                  }

                  // SET TOTAL EXCL
                  if (!this.invoice.totalExcl || this.invoice.totalExcl === 0) {
                    this.invoice.totalExcl = Math.round(e.selectedItem.totalExcl * 100) / 100 ;
                    this.invoice.totalIncl = this.invoice.totalExcl + this.invoice.totalTax;
                  }

                  const order = (await ordersService.getSingle(e.selectedItem.id)).data;
                  if (order && !this.invoice.cashDiscount && order.order.cashDiscount) {
                    this.invoice.cashDiscount = true;
                    this.invoice.cashDiscountPercentage = order.order.cashDiscountPercentage as number;
                    this.invoice.cashDiscountPeriod = order.order.cashDiscountPeriod as number;
                  }
                }
              },
            },
            editorType: 'dxAutocomplete',
            label: {
              text: 'Referentie',
            },
          },
          {
            itemType: 'simple',
            dataField: 'date',
            editorOptions: { width: '100%', useMaskBehavior: true },
            editorType: 'dxDateBox',
            label: {
              text: 'Datum',
            },
            validationRules: [
              {type: 'required', message: 'Veld is verplicht'},
            ],
          },
          {
            itemType: 'simple',
            dataField: 'dueDate',
            editorOptions: { width: '100%', useMaskBehavior: true },
            editorType: 'dxDateBox',
            label: {
              text: 'Vervaldatum',
            },
          },
        ],
      },
      {
        itemType: 'group',
        caption: 'Totalen',
        colCount: 2,
        items: [
          {
            itemType: 'simple',
            dataField: 'cashDiscount',
            editorType: 'dxCheckBox',
            label: {
              text: 'Korting contant',
              visible: true,
            },
          },
          {
            itemType: 'empty',
          },
          {
            itemType: 'simple',
            dataField: 'cashDiscountPercentage',
            editorType: 'dxNumberBox',
            label: {
              text: 'KC %',
            },
            validationRules: [
              {type: 'required', message: 'Veld is verplicht'},
            ],
            editorOptions: {
              onChange: (e: any) => {
                if (this.invoice.cashDiscountPercentage) {
                  // Minus the discount
                  this.invoice.totalInclWithCashDiscount -=
                    (this.invoice.totalExcl * this.invoice.cashDiscountPercentage / 100);

                  // Default value
                  this.invoice.totalInclWithCashDiscount += this.invoice.totalExcl + this.invoice.totalTax;

                  // Round
                  this.invoice.totalInclWithCashDiscount =
                    Math.round(this.invoice.totalInclWithCashDiscount * 100) / 100;
                }
              },
            },
            visible: this.invoice.cashDiscount,
          },
          {
            itemType: 'simple',
            dataField: 'cashDiscountPeriod',
            editorType: 'dxNumberBox',
            label: {
              text: 'KC periode',
            },
            validationRules: [
              {type: 'required', message: 'Veld is verplicht'},
            ],
            visible: this.invoice.cashDiscount,
          },
          {
            itemType: 'simple',
            dataField: 'totalExcl',
            editorType: 'dxNumberBox',
            label: {
              text: 'Totaal excl.',
            },
            validationRules: [
              {type: 'required', message: 'Veld is verplicht'},
            ],
          },
          {
            itemType: 'simple',
            dataField: 'totalTax',
            editorType: 'dxNumberBox',
            label: {
                text: 'BTW',
            },
            validationRules: [
                {type: 'required', message: 'Veld is verplicht'},
            ],
            editorOptions: {
              onChange: (e: any) => {
                this.invoice.totalIncl = this.invoice.totalExcl + this.invoice.totalTax;
              },
            },
          },
          {
            itemType: 'simple',
            dataField: 'totalIncl',
            editorType: 'dxNumberBox',
            label: {
              text: 'Totaal incl.',
            },
            validationRules: [
              {type: 'required', message: 'Veld is verplicht'},
            ],
          },
          {
            itemType: 'simple',
            dataField: 'totalInclWithCashDiscount',
            editorType: 'dxNumberBox',
            label: {
              text: 'Totaal incl. (KC)',
            },
            validationRules: [
              {type: 'required', message: 'Veld is verplicht'},
            ],
            visible: this.invoice.cashDiscount,
          },
        ],
      },
      {
        itemType: 'group',
        caption: 'Opmerkingen',
        items: [
          {
            itemType: 'simple',
            dataField: 'remarksInternal',
            editorType: 'dxTextArea',
            editorOptions: {
              height: '140px',
            },
            label: {
              text: 'Opmerkingen',
              visible: false,
            },
          },
        ],
      },
    ];
  }

  get isApprover() {
    const currentUser = this.$store.getters.currentUser;

    if (currentUser && currentUser.accountIdentifier === this.invoice.approverId) {
      return true;
    }

    return false;
  }

  get navbarItems() {
    return [
      { icon: 'fas fa-info-circle', text: 'Info'},
      { icon: 'fas fa-info-circle', text: 'Samenvatting' },
      { icon: 'fas fa-folder', text: 'Document'},
      { icon: 'fas fa-history', text: 'Geschiedenis'},
    ];
  }

  get externalInvoiceLines() {
    return this.invoice?.lines ?? [];
  }

  get externalInvoiceLineColumns() {
    return [
      {
        dataField: 'description',
        caption: 'Beschrijving',
        validationRules: [
          { type: 'required', message: 'Veld is verplicht' },
        ],
      },
      {
        dataField: 'unitPrice',
        caption: 'Eenheidsprijs (€)',
        format: {
          type: 'currency',
          precision: 4
        },
        validationRules: [
          { type: 'required', message: 'Veld is verplicht' },
        ],
        editorOptions: {
          onChange: this.setTotalPrice,
        }
      },
      {
        dataField: 'quantity',
        caption: 'Hoeveelheid',
        validationRules: [
          { type: 'required', message: 'Veld is verplicht' },
        ],
        editorOptions: {
          onChange: this.setTotalPrice,
        }
      },
      {
        dataField: 'totalPrice',
        caption: 'Totaal (€)',
        format: {
          type: 'currency',
          precision: 2,
        },
        editorOptions: {
          disabled: true
        }
      },
    ]
  }

  get extendedInvoiceLinesTable() {
    return (this.$refs as any).invoiceLinesTable?.instance as dxDataGrid;
  }

  get projectIsOnHoldPopup() {
    return (this.$refs.projectIsOnHoldPopup as ProjectIsOnHoldPopup);
  }

  get externalInvoiceDisabled() {
    return this.disabled || this.changingStatus;
  }

  @Watch('invoice', {deep: true})
  onInvoiceChange() {
    if (this.initialised && !this.changingStatus) {
      this.dirty = true;
    }
  }
}
